//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            payment: {},
            reversalReasons: {},
            reversalReasonId: 2, //@TODO: run a filter to get default from reversalReasons
            notes: '',
            remove: false,
            loading: true
        };
    },
    created: function created() {
        Event.$on('edit-ledger-payment-resident', this.editPayment);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('edit-ledger-payment-resident');
    },
    mounted: function mounted() {},

    methods: {
        editPayment: function editPayment(payment) {
            var _this = this;

            axios.get('/prototype/accounting/accounts-receivable/billings/reversal-reasons').then(function (response) {
                _this.reversalReasons = response.data;
            });

            axios.post('/prototype/resident/ledger/payments/fetch', { id: payment.id }).then(function (response) {
                _this.payment = response.data;
                _this.$children[0].showSmallModal = true;
                _this.loading = false;
            });
        },
        removePayment: function removePayment() {
            var _this2 = this;

            this.loading = true;

            var p = this.payment;
            p.deposit = null;
            p.ledger = null;
            p.reversalReasonId = this.reversalReasonId;
            p.notes = this.notes;

            axios.post('/prototype/resident/ledger/payments/destroy', p).then(function () {
                _this2.payment = {};
                _this2.$children[0].showSmallModal = false;
                _this2.remove = false;
                Event.$emit('refresh-resident-ledger');
                Event.$emit('refresh-past-resident-ledger');
            });
        },
        close: function close() {
            Event.$emit('close-small-modal');
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentModifyLedgerPayment.vue
// module id = oq3m
// module chunks = 0 1